import { useApiCampaignMember } from '@hooks-api/fortune/useApiCampaignMember'
import { type CheckoutOrder } from '@hooks-api/types/dataModel/orders'
import { Input } from '@pets-ui/Input/Input'
import { Text } from '@pets-ui/Text/Text'
import { VStack } from '@pets-ui/VStack/VStack'
import { Controller, useFormContext } from 'react-hook-form'
import { Asterisk } from '../../../../../components/Asterisk/Asterisk'
import { useCheckout } from '../../../../fp-b2b-shared/hooks/use-checkout'
import { partnerDisable } from '../../../../fp-b2b-shared/utils/partner-disable'

export function AddressMoReceiver() {
  const { watch, control } = useFormContext<CheckoutOrder>()
  const formValues = watch()
  const { campaignCode } = useCheckout()
  const { destructuredData: userInfo } = useApiCampaignMember({ code: campaignCode })
  const isPartner = partnerDisable({ roles: userInfo?.roles || [] })

  return (
    <VStack gap={4}>
      <VStack gap={1} flex="1">
        <Text variant="body">
          街道地址
          <Asterisk />
        </Text>
        <Controller
          control={control}
          name="billing_address_address1"
          rules={{ required: '此為必填欄位' }}
          render={({ field: { ref, ...field }, fieldState: { error } }) => (
            <Input
              {...field}
              value={formValues.billing_address_address1 || ''}
              rootRef={ref}
              fullWidth
              error={!!error}
              helpText={error?.message}
              placeholder="請輸入街道地址"
              disabled={isPartner}
            />
          )}
        />
      </VStack>
    </VStack>
  )
}
